import React from "react";
import BannerComp from "../Components/BannerComp";
import FooterCountryData from "../Components/Data/FooterCountryData";
import { NavLink, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import { IoMdCall, IoMdSend } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import Footer from "../Components/Footer";
import { Fade } from "react-awesome-reveal";
import { Button, Divider, Form, Input, message } from "antd";
import { FaUserCircle } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import TextArea from "antd/es/input/TextArea";
import { useCartContext } from "../context/addToCart";
import { IoArrowRedo } from "react-icons/io5";
import { MetaTags } from "react-meta-tags";

export default function BranchPage() {
  const location = useLocation();
  const { makeAndEnquiry } = useCartContext();
  const [form] = Form.useForm();

  const onFinish = (val) => {
    const name = val.first_name + " " + val.last_name;
    if (
      makeAndEnquiry(
        name,
        "",
        val.email,
        val.message,
        "Country Enquiry",
        null,
        null,
        null
      )
    ) {
      message.success(
        "Thank you for your inquiry. Our team will connect with you shortly."
      );
      form.resetFields();
    }
  };

  return FooterCountryData.filter((val) => val.slug === location.pathname).map(
    (value) => (
      <div>
        <Header />
        <MetaTags>
        <title>{value?.metaTitle}</title>
        <meta title={value?.metaTitle} />
        <meta name="description" content={value?.metaDescription} />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href={value?.metaCanonical} />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content={value?.metaTitle} />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content={value?.metaDescription} />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>
        <BannerComp
          image={value.imageBanner}
          title={value.countryName}
          breadcrumb={[
            {
              title: "Home",
              href: "/",
            },
            {
              title: "Location",
            },
            {
              title: value.countryName,
            },
          ]}
        />

        <section className="sectionDiv">
          {value.img && (
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <h6 className="text-dark" style={{ color: "#000" }}>
                    Worldwide Dealers
                    <small
                      className="text-gray mx-2"
                      style={{ color: "#808080" }}
                    >
                      Spread across the globe to best serve our clients!
                    </small>
                  </h6>
                  <Divider />
                  <h2 className="">{value.countryName}</h2>
                  <Divider />

                  <Fade triggerOnce direction="up">
                    <div className="detail mt-5">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="detail-card">
                            <div className="icon">
                              <FaLocationDot style={{ color: "#000" }} />
                            </div>
                            <div className="content">
                              <h5 style={{ color: "#000" }}>
                                {value?.location}
                              </h5>
                              <p style={{ color: "#000" }}>{value?.address}</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="detail-card">
                            <div className="icon">
                              <IoMdCall style={{ color: "#000" }} />
                            </div>
                            <div className="content">
                              <h5 style={{ color: "#000" }}>Contact Us</h5>
                              <p style={{ color: "#000" }}>
                                Phone: {value?.phoneNumber}
                              </p>
                              <p style={{ color: "#000" }}>
                                Email: {value?.email}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
                <div className="col-md-4 mt-5 mt-md-0">
                  <Fade triggerOnce direction="right">
                    <div
                      className="formCard"
                      style={{ boxShadow: "0 0 3px #afafaf" }}
                    >
                      <div className="formTitle">Contact Us</div>
                      <Form form={form} onFinish={onFinish}>
                        <div className="row">
                          <div className="col-md-6">
                            <Form.Item
                              name="first_name"
                              rules={[{ required: true }]}
                            >
                              <Input
                                prefix={<FaUserCircle />}
                                style={{ borderRadius: 0, height: 45 }}
                                placeholder="First Name"
                              />
                            </Form.Item>
                          </div>
                          <div className="col-md-6">
                            <Form.Item
                              name="last_name"
                              rules={[{ required: true }]}
                            >
                              <Input
                                prefix={<FaUserCircle />}
                                style={{ borderRadius: 0, height: 45 }}
                                placeholder="Last Name"
                              />
                            </Form.Item>
                          </div>
                          <Form.Item name="email" rules={[{ required: true }]}>
                            <Input
                              prefix={<MdEmail />}
                              style={{ borderRadius: 0, height: 45 }}
                              placeholder="Email"
                            />
                          </Form.Item>
                          <Form.Item
                            name="message"
                            rules={[{ required: true }]}
                          >
                            <TextArea
                              style={{ borderRadius: 0 }}
                              rows={5}
                              showCount
                              placeholder="Message"
                            />
                          </Form.Item>
                          <Form.Item>
                            <Button className="submitForm" htmlType="submit">
                              SEND MESSAGE <IoMdSend />
                            </Button>
                          </Form.Item>
                        </div>
                      </Form>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          )}
          {value?.produtList && (
            <div className="container mt-5">
              {value.countryName === "USA" ? <Divider /> : null}
              <div className="productLists">
                <div className="row">
                  {value?.produtList.map((val) => (
                    <div className="col-md-4 mb-4">
                      <NavLink to={val.slug}>
                        <div className="productCard">
                          <h5>{val.title}</h5>
                          <p>
                            {val.desc}
                          </p>
                          <span>
                            <IoArrowRedo />
                          </span>
                        </div>
                      </NavLink>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {value?.desc1 && (
            <div className="container mt-5">
              <Divider />
              <p style={{ textAlign: "justify" }}>{value?.desc1}</p>
              <p style={{ textAlign: "justify" }}> {value?.desc2}</p>
              <p style={{ textAlign: "justify" }}>{value?.desc3}</p>
            </div>
          )}
        </section>
        <Footer />
      </div>
    )
  );
}
